import React, { Component } from "react";

class CheckoutSummary extends Component {
  render() {
    const { event, cart, total, envelope, freeTicket } = this.props;
    return (
      <div className="w-full lg:w-1/3 lg:float-right sticky pin-t pin-r p-4 z-50 border-primary bg-accent mx-0 checkOutSummary">
        <h4 className="py-2">Your Order</h4>
        {freeTicket ?
          (<div className="flex py-2">
            <div className="flex-2">
              <span className="font-semibold">{`Free Ticket(s)`}</span>
            </div>
            <div className="flex-1 text-right">$0</div>
          </div>)
        :
        (cart && cart.map((c, k) => {
          if (c.qty === 0) return false;
          return (
            <div key={k} className="flex py-2">
              <div className="flex-2">
                <span className="orderBreakdown">{`${c.qty} x `}
                  <strong>
                    {c.cost ? `${c.tickets} ticket(s) for $${c.cost}` : `${c.tickets} ticket(s)`}
                  </strong>
                </span>
              </div>
              {c.cost && <div className="flex-1 text-right">${c.qty * c.cost}</div>}
            </div>
          );
        }))}
        {event.game.id === 3 && envelope > 0 && (
          <div className="flex py-2">Your envelope # :<span className="flex-1 text-right">{envelope}</span></div>
        )}
        {!freeTicket && total === 0 && (
          <div className="flex py-2">Your cart is empty !</div>
        )}
        <div className="flex py-2 font-bold border-t">
          <div className="flex-1">Total:</div>
          <div className="flex-1 text-right">{freeTicket ? '$0' : `$${total}`}</div>
        </div>
      </div>
    );
  }
}

export default CheckoutSummary;
